import capitalize from 'lodash/capitalize';
import type React from 'react';

import type { BuildType } from 'src/enums/build/build-type';
import type { Language } from 'src/enums/language';
import { amplitudeLinkTrackEvent } from 'src/helpers/amplitude-event-track';

export const onMarkdownLinkClick =
  (buildType: BuildType, language: Language, componentName: string) =>
  (href: string | undefined, children: React.ReactNode) => {
    void amplitudeLinkTrackEvent({
      buildType,
      language,
      linkName: typeof children === 'string' ? capitalize(children) : undefined,
      linkPath: href ?? null,
      linkEventName: 'Markdown Link',
      componentName,
    });
  };
